export default __webpack_public_path__ + "static/media/anezka-image-cropped.536a4dd4.svg";